import React from 'react';
import { Alert, Button, Col, Tabs, Tab, Row, Modal } from 'react-bootstrap';
import EditCheckSetComponent from '../components/EditCheckSetComponent.jsx';
import AppendCheckItemComponent from '../components/AppendCheckItemComponent.jsx';

export default class ManageCheckItemComponent extends React.Component {

    constructor(props) {
        super(props);
        this.onTabsChange = this.onTabsChange.bind(this);
    }

    componentWillMount() {
        this.props.findCheckCategories();
    }

    onTabsChange(key) {
        this.props.changeCategory(key);
    }

    toSummaryTable(detailArray) {
        let cloth = new Map();
        let pant = new Map();

        for (var index = 0; index < detailArray.length; index++) {
            let detail = detailArray[index];
            let mapKey = detail.checkSet.description;
            let count = 0;
            if (/*cloth*/1 === detail.checkCategory.id) {
                if (undefined === cloth.get(mapKey)) {
                    cloth.set(mapKey, 1);
                } else {
                    count = cloth.get(mapKey);
                    cloth.set(mapKey, 1 + count);
                }
            } else if (/*pant*/2 === detail.checkCategory.id) {
                if (undefined === pant.get(mapKey)) {
                    pant.set(mapKey, 1);
                } else {
                    count = pant.get(mapKey);
                    pant.set(mapKey, 1 + count);
                }
            }
        }
        let clothRow = [];
        for (let key of cloth.keys()) {
            clothRow.push('' + key + '(' + cloth.get(key) + ')');
        }
        let pantRow = [];
        for (let key of pant.keys()) {
            pantRow.push('' + key + '(' + pant.get(key) + ')');
        }

        let ret = [];
        ret.push(clothRow);
        ret.push(pantRow);
        return ret;
    }

    toSetsMap(setArray) {
        /* for grid view: 3 columns */
        let rows = [];
        for (var index = 0; index < setArray.length; index += 3) {
            let map = new Map();
            map.set('left', setArray[index]);
            map.set('middle', setArray[index + 1]);
            map.set('right', setArray[index + 2]);
            rows.push(map);
        }
        return rows;
    }

    render() {
        let cats = this.props.view.get('categories');
        let cat = cats[this.props.request.get('category')];
        let alertDiv = null;
        let tab1 = null;
        let tab2 = null;

        let isCardDisable = false;  //原225行，修改warning往上移

        if (this.props.alert.get('style') || this.props.alert.get('message')) {
            alertDiv = (
                <Alert bsStyle={this.props.alert.get('style')}>{this.props.alert.get('message')}</Alert>
            );
        }

        if (cats.length >= 1) {
            tab1 = (
                <Tab eventKey={0} title={cats[0].description}>
                    <div style={{ marginTop: 10 }}>
                        {
                            this.toSetsMap(cat.checkSets).map(
                                (row, index) =>
                                    <Row key={index} className="clearfix" style={{ marginBottom: 1 }}>
                                        <Col xs={4} sm={4} md={4}>
                                            <EditCheckSetComponent ckset={row.get('left')}
                                                category={cat}
                                                disabled={isCardDisable}
                                                onEditItem={(category, ckSet, ckItem) => {
                                                    this.props.showOrHideCheckItem(ckItem);
                                                }
                                                }
                                                onShowAddItem={(category, ckSet) => {
                                                    this.props.showModal(category, ckSet);
                                                }}
                                                onDeleteItem={(ckItemId) => {
                                                    this.props.deleteItem(ckItemId);
                                                }}
                                            />

                                        </Col>
                                        <Col xs={4} sm={4} md={4}>
                                            {undefined === row.get('middle') ? '' :
                                                <EditCheckSetComponent ckset={row.get('middle')}
                                                    category={cat}
                                                    disabled={isCardDisable}
                                                    onEditItem={(category, ckSet, ckItem) => {
                                                        this.props.showOrHideCheckItem(ckItem);
                                                    }
                                                    }
                                                    onShowAddItem={(category, ckSet) => {
                                                        this.props.showModal(category, ckSet);
                                                    }}
                                                    onDeleteItem={(ckItemId) => {
                                                        this.props.deleteItem(ckItemId);
                                                    }}
                                                />
                                            }
                                        </Col>
                                        <Col xs={4} sm={4} md={4}>
                                            {undefined === row.get('right') ? '' :
                                                <EditCheckSetComponent ckset={row.get('right')}
                                                    category={cat}
                                                    disabled={isCardDisable}
                                                    onEditItem={(category, ckSet, ckItem) => {
                                                        this.props.showOrHideCheckItem(ckItem);
                                                    }
                                                    }
                                                    onShowAddItem={(category, ckSet) => {
                                                        this.props.showModal(category, ckSet);
                                                    }}
                                                    onDeleteItem={(ckItemId) => {
                                                        this.props.deleteItem(ckItemId);
                                                    }}
                                                />
                                            }
                                        </Col>
                                    </Row>
                            )
                        }
                    </div>
                </Tab>
            );
        }

        if (cats.length >= 2) {
            tab2 = (
                <Tab eventKey={1} title={cats[1].description}>
                    <div style={{ marginTop: 10 }}>
                        {
                            this.toSetsMap(cat.checkSets).map(
                                (row, index) =>
                                    <Row key={index} className="clearfix" style={{ marginBottom: 1 }}>
                                        <Col xs={4} sm={4} md={4}>
                                            <EditCheckSetComponent ckset={row.get('left')}
                                                category={cat}
                                                disabled={isCardDisable}
                                                onEditItem={(category, ckSet, ckItem) => {
                                                    this.props.showOrHideCheckItem(ckItem);
                                                }}
                                                onShowAddItem={(category, ckSet) => {
                                                    this.props.showModal(category, ckSet);
                                                }}
                                                onDeleteItem={(ckItemId) => {
                                                    this.props.deleteItem(ckItemId);
                                                }}
                                            />
                                        </Col>
                                        <Col xs={4} sm={4} md={4}>
                                            {undefined === row.get('middle') ? '' :
                                                <EditCheckSetComponent ckset={row.get('middle')}
                                                    category={cat}
                                                    disabled={isCardDisable}
                                                    onEditItem={(category, ckSet, ckItem) => {
                                                        this.props.showOrHideCheckItem(ckItem);
                                                    }}
                                                    onShowAddItem={(category, ckSet) => {
                                                        this.props.showModal(category, ckSet);
                                                    }}
                                                    onDeleteItem={(ckItemId) => {
                                                        this.props.deleteItem(ckItemId);
                                                    }}
                                                />
                                            }
                                        </Col>
                                        <Col xs={4} sm={4} md={4}>
                                            {undefined === row.get('right') ? '' :
                                                <EditCheckSetComponent ckset={row.get('right')}
                                                    category={cat}
                                                    disabled={isCardDisable}
                                                    onEditItem={(category, ckSet, ckItem) => {
                                                        this.props.showOrHideCheckItem(ckItem);
                                                    }}
                                                    onShowAddItem={(category, ckSet) => {
                                                        this.props.showModal(category, ckSet);
                                                    }}
                                                    onDeleteItem={(ckItemId) => {
                                                        this.props.deleteItem(ckItemId);
                                                    }}
                                                />
                                            }
                                        </Col>
                                    </Row>
                            )
                        }
                    </div>
                </Tab>
            );
        }
        // let sumary = this.toSummaryTable(this.props.view.get('details'));
        // let clothRows = this.toSummaryRows(sumary[0], '消防衣');
        // let pantRows = this.toSummaryRows(sumary[1], '消防褲');
        // let isCardDisable = ('COMPLETED'===this.props.view.get('card').status);
        // let isCardDisable = false;

        return (
            <div><span hidden>清洗項目管理ManageCheckItemComponent</span>
                <h4>清洗項目管理
                    <a href="doc/check_item_mgmt.html" target="_blank">&nbsp;&nbsp;
                        <img src='question.svg' height="18" width="18" alt='清洗項目管理使用說明' />
                    </a>
                </h4>
                {alertDiv}
                <Tabs id="ckTabs" defaultActiveKey={this.props.request.get('category')} animation={false} onSelect={this.onTabsChange}>
                    {tab1}
                    {tab2}
                </Tabs>
                <Modal show={this.props.modal.get('show')} onHide={this.props.hideModal} backdrop="static">
                    <Modal.Header closeButton >
                        <Modal.Title id="add-checked-item">新增清點項目</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <AppendCheckItemComponent
                            request={this.props.modal.get('request')}
                            cat={this.props.modal.get('category')}
                            checkSet={this.props.modal.get('ckSet')}
                            onAppendCkItem={(ckSet) => {
                                this.props.appendCheckItem(
                                    ckSet,
                                    this.props.modalRequest.get('description'),
                                    this.props.modalRequest.get('price'),
                                    this.props.modalRequest.get('note'));
                                this.props.hideModal();
                            }}
                            onDescriptionChange={(value) => this.props.setDescription(value)}
                            onPriceChange={(value) => this.props.setPrice(value)}
                            onNoteChange={(value) => this.props.setNote(value)}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={(event) => { this.props.hideModal() }} >離開</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./src/components/ManageCheckItemComponent.jsx